import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { gameModel } from 'entities/game';
import { ActionIcon, Button } from 'shared/ui';
import HomeIcon from 'shared/ui/assets/icons/home-icon.svg?react';
import { sidebarModel } from '../../model';

export const SidebarHomeButton = () => {
	const { t } = useTranslation();
	const [returnUrl, returnHome] = useUnit([gameModel.$returnUrl, sidebarModel.returnHome]);

	const validReturnUrl = returnUrl && returnUrl.length > 0;

	return (
		validReturnUrl && (
			<Button
				variant='standard'
				leftSection={
					<ActionIcon
						variant='secondary'
						component='div'
					>
						<HomeIcon />
					</ActionIcon>
				}
				onClick={returnHome}
			>
				{t('sidebar.home-button-label')}
			</Button>
		)
	);
};
